import classNames from 'classnames/bind';
import styles from './ProjectPreview.module.scss';
import images from '~/assets';
import ProjectItem2 from '~/component/ProjectItem/ProjectItem2';
import { useEffect, useState, useRef, useContext } from 'react';
import { getData } from '~/helper/apiService';
import TitleComp from '~/component/TitleComp';
import { useDarkMode } from '~/hooks/useDarkMode';
import { ThemeModeContext } from '~/component/Context/ThemeModeProvider';
import TitleComp2 from '~/component/TitleComp2';

const cx = classNames.bind(styles);

function ProjectPreview() {
  const [projects, setProjects] = useState([]);
  const listRef = useRef(null);
  const { theme } = useContext(ThemeModeContext);
  const [isDarkMode, setIsDarkMode] = useState(useDarkMode());

  useEffect(() => {
    setIsDarkMode(theme === 'dark' ? true : false);
  }, [theme]);

  useEffect(() => {
    const loadData = async () => {
      const data = await getData('/projects/read');
      if (data.length > 0) {
        // Clone danh sách để tạo hiệu ứng vô hạn
        setProjects([...data, ...data, ...data, ...data]);
      }
    };
    loadData();
  }, []);

  return (
    <div className={cx('wrapper')}>
      <TitleComp2 className={cx("title")}>Dự án</TitleComp2>
      <div className={cx('background-container')}>
        {/* {isDarkMode && <img className={cx('background-image')} src={images.githubBanner} alt="Background" />} */}
        <div className={cx('container')}>
          <div className={cx('content')}>
            <div className={cx('project-list-wrapper')}>
              <div className={cx('project-list')} ref={listRef}>
                {projects.map((project, index) => (
                  <ProjectItem2 data={project} key={index} />
                ))}
              </div>{' '}
              <div className={cx('project-list')} ref={listRef} style={{ animationDirection: 'reverse' }}>
                {projects.map((project, index) => (
                  <ProjectItem2 data={project} key={index} />
                ))}
              </div>
            </div>
            <a className={cx('description')} href="https://github.com/ngogiaquyen" target='blank'>
              https://github.com/ngogiaquyen
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ProjectPreview;
